module.exports = __webpack_public_path__ + "card1-v1.e3a7ac6d94a2ca40cb01e5e0320b8350.jpg";